import React from "react";
import {connect} from "react-redux";

import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Table from "components/Table/Table.jsx";
import Checkbox from "components/Checkbox/Checkbox";
import Add from "@material-ui/icons/Add";
import Create from "@material-ui/icons/Create";
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import {
  ibSave,
  //ibsFetch,
  ibFetch
} from 'actions/ibs'

import {
  danger,
} from 'actions/notification'

const departments = {
	busresp: 'Business Responsible',
	itresp: 'IT Responsible',
	fixresp: 'FIX Responsible (if not IT)',
	headtrading: 'Head of Trading',
	other: 'Other Key Personnel',
}

class IbContactPersons extends React.Component {
	state = {
		selected: -1,
		showForm: false,
		form:{
			department: '',
			func: '',
			phoneNumber: '',
			email: ''
		},
		ib:{
			contactPeople: []
		}
  }

	componentDidMount() {
		if(this.props.match.params.id) {
			this.props.saveWizardData(this.props.stepDataObject.data)
			this.setState({
				...this.state,
				ib: {
					contactPeople: this.props.stepDataObject.data.contactPeople
				}
			})
		}
	}

	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: <small>(optional)</small>)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}
	addNew(){
		this.setState({
			...this.state,
			showForm: true,
			form:{
				department: '',
				func: '',
				phoneNumber: '',
				email: ''
			}
		})
		
	}
	saveTableItem(e){
		e.preventDefault()
		const state = this.state
		let ib = this.state.ib
		const newPerson = {
			department: this.state.form.department,
			function: this.state.form.func,
			email:  this.state.form.email,
			phoneNumber: this.state.form.phoneNumber
		}
		if(this.state.form.contactPersonId){
			newPerson.contactPersonId = this.state.form.contactPersonId
			ib.contactPeople = ib.contactPeople.filter((x) => x.contactPersonId !== newPerson.contactPersonId)
		}
		
		ib.contactPeople.push(newPerson)
		let data = {...this.props.wizardData, ...ib}
    this.props.save(data)
      .then(e => {
				this.props.fetch(e.ibId)
					.then((res) => {
						this.props.saveWizardData(e)
						this.setState({
							...state,
							ib:{
								contactPeople: res.contactPeople
							},
							showForm: false
						})

					})
        //this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
	}
	closeForm(){
		this.setState({
			...this.state,
			showForm: false
		})
	}
	renderAddItemForm(){
		const {classes} = this.props
		return(
			<form onSubmit={(e) => this.saveTableItem(e)}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={11} md={11}>

					<FormControl
            fullWidth
            className={classes.selectFormControl}
            style={{marginTop:'10px', marginBottom: '17px'}}
          >

            <InputLabel
              htmlFor="nationality"
              className={classes.selectLabel}
            >
              Department*
            </InputLabel>

            <Select
              required={true}
              native
              value={this.state.form.department || '' }
              MenuProps={{ className: classes.selectMenu }}
              classes={{ select: classes.select }}            
              inputProps={{
                onChange: event => this.change(event, "department"),
                id: "department"
              }}
            >
              <option value="" disabled></option>
              {Object.values(departments).map(item => 
                <option key={item} value={item}>{item}</option>
              )}
            </Select>  
          </FormControl>
						
						{this.getInput({
							key:'func',
							name:'Tittle & Function',
							icon:'',
							type:'text',
							required:true
						})}
						
						{this.getInput({
							key:'phoneNumber',
							name:'Direct Phone Number',
							icon:'',
							type:'text',
							required:true
						})}
						
						{this.getInput({
							key:'email',
							name:'Email Address',
							icon:'',
							type:'text',
							required:true
						})}
					</GridItem>
					<GridItem xs={12} sm={11} md={11}>
					<div style={{float: 'right'}}>
						<Button
							color="danger"
							type="button"
							onClick={(e) => this.closeForm()}
						>
							Cancel
						</Button>
						<Button
							color="success"
							type="submit"
						>
							{this.state.form.contactPersonId ? 'Edit' : 'Add'}
						</Button>
					</div>
					</GridItem>
				</GridContainer>
			</form>
		)

	}
	select(id){
		let selected = this.state.selected === id ? -1 : id
		this.setState({
			...this.state,
			selected: selected
		})
	}
	editFormItem(e){
		const {ib:{contactPeople}, selected} = this.state
		const itemToEdit = contactPeople.find((x) => x.contactPersonId === selected)
		itemToEdit.func = itemToEdit.function
		this.setState({
			...this.state,
			form: itemToEdit,
			showForm: true
		})
	}
	deleteItem(id){
		let ib = this.state.ib
		ib.contactPeople = ib.contactPeople.filter((x) => x.contactPersonId !== id)
		let data = {...this.props.wizardData, ...ib}
    this.props.save(data)
      .then(e => {
				this.props.fetch(e.ibId)
					.then((res) => {
						this.setState({
							...state,
							ib:{
								...res,
              	companyId: res.company ? res.company.companyId : '',
							},
							showForm: false
						})

					})
        //this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})

	}
  render() {
		//const {classes} = this.props
		let {showForm, ib} = this.state
		
		return (
			<GridContainer justify="center">

				{!showForm && (
					<GridContainer justify="center">
					
						<GridItem xs={11} sm={11}>
							<div style={{float: 'right'}}>
								<span
									onClick={() => this.addNew()}
								>
									<Add
										style={{
											boxShadow: '0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)',
											backgroundColor: '#00acc1',
											color: 'white',
											border: 'transparent',
											height: '30px',
											width: '30px',
											borderRadius: '50%',
											cursor: 'pointer'
										}}
									/>
								</span>
							</div>
							
						</GridItem>
						<GridItem xs={11} sm={11} md={11}>
						
							<div style={{border:'1px solid #AAAAAA', marginTop: '20px'}}>
								<Table
									tableHeaderColor="primary"
									striped
									responsiveY
									tableHead={{
										checkbox: '#',
										department: 'Department',
										func:"Tittle & Function", 
										phoneNumber:"Direct Phone Number",
										email:"Email Address", 
										actions: ''
									}}
									tableData={ib.contactPeople.sort((a, b) => a - b).map((e,i) => [
										<Checkbox props={{
											onClick:()=>this.select(e.contactPersonId),
                      checked:this.state.selected===e.contactPersonId
										}} />,
										e.department,
										e.function,
										e.phoneNumber,
										e.email,
										<div>
											<span
												style={{
													cursor: 'pointer',
													visibility: this.state.selected === e.contactPersonId ? 'visible' : 'collapse'
												}}
												onClick={(e) => this.editFormItem(e)}
											>
												<Create />
											</span>

											<span
												style={{
													color: '#f44336',
													cursor: 'pointer',
													visibility: this.state.selected === e.contactPersonId ? 'visible' : 'collapse'
												}}
												onClick={(x) => this.deleteItem(e.contactPersonId)}
											>
												<Close />
											</span>
										</div>
									])}
								/>
							</div>
						</GridItem>
					</GridContainer>
				)}
				
				{showForm && (
					this.renderAddItemForm()
				)}

				<GridItem sm={11}>
					<div style={{float: 'left'}}>
						<Button
							// color="success"
							type="button"
							onClick={(e) => this.props.goToPreviousStep(ib)}
							style={{position:'absolute', bottom:'10px', left:'40px'}}
						>
							Previous
						</Button>
					</div>
					<div style={{float: 'right'}}>
						<Button
							color="success"
							type="button"
							onClick={(e) => this.props.goToNextStep(ib)}
							style={{position:'absolute', bottom:'10px', right:'40px'}}
						>
							Next
						</Button>
					</div>
				</GridItem>
			</GridContainer>
		)
  }
}
const state=(state)=>({
  ibs: state
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
})
export default withStyles(styles)(connect(state,dispatch)(IbContactPersons))



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/IbContactPersons.jsx